import { useLocation } from "react-router-dom";

const SidebarLink = ({ children }) => {
  const location = useLocation();
  if (location?.pathname?.includes("supervision-mode")) return null;
  return children;
};

export default SidebarLink;
